import { Module } from '../../types'

export const createCardFrictionlessFlowMobileConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumnProductHeading',
      left: [{ __typename: 'ModuleHeading' }],
      right: [{ __typename: 'ModulePills', show: 'primary only' }],
    },
    { __typename: 'ModuleImages' },
    { __typename: 'ModuleMemberPricingHeader' },
    {
      __typename: 'ModuleVariantTabs',
      modules: [],
    },
    { __typename: 'ModuleProductDetails' },
    { __typename: 'ModuleButtons' },
  ]
}
